import React from 'react';
import '../style/css/footer.css'
import logofooter from '../style/imges/logofooter.png'


const MainFooter = () => {
    return (
        <div className={'footer-container'}>
            <div className={'logo-container flex ai-c'}>
                <div className={'company'}>BY LEGA6</div>
                <div className={'logo'}><img className={'icon-logo-footer'} src={logofooter}/></div>
            </div>
        </div>
    );
};

export default MainFooter;